<template>
  <div>
    <el-drawer
      title="礼品卡详情"
      :visible.sync="drawerVisible"
      :direction="direction"
      :size="size"
      :before-close="handleClose"
      custom-class="c-drawer"
    >
      <div class="drawer-content">
        <el-form
          ref="formRef"
          :model="giftCardInfo"
          style="width:100%"
          :label-position="'right'"
          size="small"
          label-width="120px"
          disabled
        >
          <el-col :span="12">
            <el-form-item label="卡号">
              <el-input v-model="giftCardInfo.cardNo" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡片名称">
              <el-input v-model="giftCardInfo.cardName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡片类型">
              <el-input
                v-model="giftCardInfo.cardTypeName"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员信息">
              <el-input v-model="subscriberInfo" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购买时间">
              <el-input v-model="giftCardInfo.buyTime" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购买金额">
              <el-input v-model="giftCardInfo.buyAmount" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡片面值">
              <el-input v-model="giftCardInfo.amount" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="余额">
              <el-input v-model="giftCardInfo.balance" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="激活时间">
              <el-input v-model="giftCardInfo.activeTime" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过期时间">
              <el-input v-model="giftCardInfo.expiredTime" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-input v-model="giftCardInfo.statusName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="giftCardInfo.remark"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div class="editOpera-seat"></div>
      <div class="drawer-footer">
        <div class="operation">
          <el-button @click="handleClose">取消</el-button>
          <!-- <el-button type="primary">保存</el-button> -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "GiftCardRecordInfo",
  components: {},
  props: {
    giftCardInfo: {
      type: Object,
      default: () => {}
    },
    drawerVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subscriberInfo() {
      return `${this.giftCardInfo.subscriberName || ""}/${this.giftCardInfo
        .subscriberPhone || ""}`;
    },
    disabled() {
      return function(v) {
        switch (v) {
          default:
            return false;
        }
      };
    }
  },
  data() {
    return {
      direction: "rtl",
      size: "50%"
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.c-drawer {
  width: 100%;
  height: 100%;
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
    form {
      flex: 1;
    }
    //   //距离bottom
    //   .editor {
    //     height: 300px;
    //     margin-bottom: 100px;
    //   }
    //   .explain {
    //     font-size: 12px;
    //     color: #999;
    //     margin-top: 8px;
    //     line-height: 1.5;
    //   }
  }
  .editOpera-seat {
    width: 100%;
    height: 54px;
  }
  .drawer-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 4px 4px;
    z-index: 30;
    display: flex;
    /** 操作 靠右 */
    .operation {
      margin-left: auto;
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// infoRecord.vue?0fae697f